// Central site / brand configuration
export const SITE = {
  name: "Plastic Surgery Vietnam",
  domain: "plastic-surgery-vietnam.com",
  url: "https://plastic-surgery-vietnam.com",
  tagline: "Independent international patient support",
  email: "support@vietclinics.com",
  phone: "+84 38 649 2508",
  phoneHref: "tel:+84386492508",
  whatsapp: "+84 38 649 2508",
  whatsappHref: "https://wa.me/84386492508",
  languages: [
    { code: "en", label: "EN", name: "English", prefix: "" },
    { code: "fr", label: "FR", name: "Français", prefix: "/fr" },
    { code: "de", label: "DE", name: "Deutsch", prefix: "/de" },
  ],
};

// Independence disclaimer used across the site
export const DISCLAIMER_SHORT =
  "Plastic Surgery Vietnam is an independent patient-support and coordination platform. It is not a clinic, hospital or medical provider.";

export const DISCLAIMER_LONG =
  "Plastic Surgery Vietnam is an independent international patient information and coordination platform. It is not a clinic, hospital, doctor or medical provider. It does not diagnose conditions or provide medical treatment. All clinical decisions are made by licensed medical professionals and authorised healthcare facilities.";
